import React from 'react';
import CreateAccountForm from 'Forms/CreateAccountForm';
import { createUserAccount } from 'Utils/SignInHelpers';

export const CreateEmailComponent = ({ onSignInSuccess, onSignUpSuccess, ...formProps }) => {
  return (
    <CreateAccountForm
      {...formProps}
      onFormSubmit={(values) => createUserAccount(values, onSignInSuccess, onSignUpSuccess)}
    />
  );
};

export default CreateEmailComponent;
